import { render, staticRenderFns } from "./notes-form.vue?vue&type=template&id=dc014fee&scoped=true&"
import script from "./notes-form.vue?vue&type=script&lang=js&"
export * from "./notes-form.vue?vue&type=script&lang=js&"
import style0 from "./notes-form.vue?vue&type=style&index=0&id=dc014fee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc014fee",
  null
  
)

/* custom blocks */
import block0 from "./notes-form.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports